module.exports = __webpack_public_path__ + "static/banner3-2d042b6244ab07d17a6a061e7b9ed8f1.jpg";